import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

import {App} from './App';
import {store} from './store';
import {start} from './store/actions/start';
import './components/base.scss';
import 'src/styles/base.scss';

store.dispatch(start());

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app')
);

window.XHS = window.XHS || {};
window.XHS.store = store;
